import React from 'react';
import { Link } from 'react-router-dom';
import Container from './Container';
import SiteLogo from './SiteLogo';

const NAVY = '#1c3244';
const GOLD = '#A08D45';
const CREAM = '#F9EFDD';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Product: [
      { name: 'Features', href: '/features' },
      { name: 'Pricing', href: '/subscription' },
      { name: 'Templates', href: '/template-selection' },
    ],
    Company: [
      { name: 'About Us', href: '/about' },
      { name: 'Contact Us', href: '/contact' },
      { name: 'Privacy Policy', href: '/privacy-policy' },
      { name: 'Terms & Conditions', href: '/terms-and-conditions' },
      { name: 'Community Guidelines', href: '/community-guidelines' },
    ],
  };

  return (
    <footer style={{ backgroundColor: NAVY }}>
      <Container>
        <div className="py-14 sm:py-16 md:py-24">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 sm:gap-12 md:gap-14 mb-14 sm:mb-16">
            <div className="col-span-1 sm:col-span-2 md:col-span-1">
              <Link to="/" className="inline-block mb-5">
                <SiteLogo imgClassName="h-14 w-14" />
              </Link>
              <p
                className="text-sm leading-relaxed max-w-sm"
                style={{
                  color: 'rgba(249,239,221,0.65)',
                  fontFamily: "'Open Sans', sans-serif",
                }}
              >
                Create meaningful legacy videos that preserve your stories for generations to come.
              </p>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h3
                  className="font-medium text-xs mb-5 sm:mb-6 uppercase tracking-[0.18em]"
                  style={{ color: GOLD, fontFamily: "'Open Sans', sans-serif" }}
                >
                  {title}
                </h3>
                <ul className="space-y-3 sm:space-y-4">
                  {links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.href}
                        className="text-sm transition-colors duration-200 hover:opacity-100"
                        style={{
                          color: 'rgba(249,239,221,0.7)',
                          fontFamily: "'Open Sans', sans-serif",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = CREAM;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = 'rgba(249,239,221,0.7)';
                        }}
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div
            className="pt-10"
            style={{ borderTop: '1px solid rgba(249,239,221,0.15)' }}
          >
            <p
              className="text-xs uppercase tracking-[0.15em] text-center md:text-left"
              style={{
                color: 'rgba(249,239,221,0.45)',
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              © {currentYear} The Sizzleisland Company Limited. All rights reserved.
            </p>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
